import { FC, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { GridActionsCellItem, GridRowParams } from '@mui/x-data-grid';
import { Visibility, Delete } from '@mui/icons-material';

import { Job } from '@libs/models';
import { useJobSearchQuery } from '@carcareers/store';
import { DashboardPageContainer, DataGridV2 as DataGrid } from '@carcareers/components';
import { useJob } from '@carcareers/hooks';
import { JOB_INDEX_COLUMNS, JOB_INDEX_COLUMN_INITIAL_STATE, routes } from '@carcareers/utils';

export const EmployerJobIndex: FC = () => {
  const navigate = useNavigate();
  const { deleteJob } = useJob();
  const search = useJobSearchQuery;

  const columns = useMemo(() => [
    ...JOB_INDEX_COLUMNS,
    {
      field: 'actions',
      type: 'actions' as const,
      flex: 1,
      align: 'right' as const,
      headerAlign: 'right' as const,
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
          showInMenu
          key={`view-${params.row.id}`}
          label="View"
          icon={<Visibility />}
          onClick={() =>
            navigate(`/${routes.EMPLOYER_HOME}/${routes.EMPLOYER_JOBS_VIEW.replace(':id', params.row.id?.toString() ?? '')}`)
          }
        />,
        <GridActionsCellItem
          showInMenu
          key={`delete-${params.row.id}`}
          label="Delete"
          icon={<Delete color="error" />}
          onClick={() => deleteJob(params.row.id)}
        />,
      ],
    },
  ], [navigate, deleteJob]);

  return (
    <DashboardPageContainer>
      <DataGrid<Job>
        query={search}
        columns={columns}
        initialState={{
          columns: {
            columnVisibilityModel: JOB_INDEX_COLUMN_INITIAL_STATE,
          },
        }}
      />
    </DashboardPageContainer>
  );
};

export default EmployerJobIndex;
